import React from 'react';
import { useHistory } from 'react-router-dom';
import { getRoundMatches } from '../../../api/getRoundMatches';
import * as func from '../../../utils/funcs';

import styles from './RoundTable.module.css';
import editIcon from './../../../graphics/icons/edit.svg';
import whisleIcon from './../../../graphics/icons/whisle.svg';

function RoundTable(props) {
  const { user, leagueId, round, setMatches } = props;
  const history = useHistory();
  const [roundMatches, setRoundMatches] = React.useState([]);
  const [isLoaded, setIsLoaded] = React.useState(false);

  React.useEffect(() => {
    let mounted = true;

    getRoundMatches(leagueId, round.id).then((data) => {

      if (mounted && !data.error) {
        setRoundMatches(data);
        setIsLoaded(true);
      }
    });
    return function cleanup() {
      mounted = false;
    };
  }, [leagueId, round]);

  const showGoals = (match, teamId) => match.match_results.filter((team) => team.team_id ===
    teamId)[0].goals;

  return (<div className={styles.roundTable}>
    {roundMatches.length > 0 ? (roundMatches.map((match, index) => (<div
      className={`${styles.row} ${index % 2 !== 0 && styles.odd}`}
      key={match.id}
    >
      {(match.teams[0] && match.teams[1]) ? <>
          {match.teams[0] && <div>
            <div className={styles.groupName}>{match.teams[0] && match.teams[0].name}</div>
            <img
              className={styles.groupImg}
              src={match.teams[0].image !== null ? match.teams[0].image :
                'https://images.unsplash.com/photo-1527871252447-4ce32da643c6?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=2389&q=80'}
              alt={match.teams[0].name}
            />
          </div>}

          <div>
            {func.validRakazLeague(user) ? (<img
              className={styles.iconEdit}
              src={editIcon}
              alt="עריכת משחק"
              onClick={() => {
                setMatches(roundMatches);
                history.push(`/leagues/${leagueId}/rounds/${round.id}/matches/${match.id}/edit`);
              }}
            />) : (<span></span>)}
          </div>

          <div className={styles.score}>
            {match.is_finished ? (<div className={styles.result}>
              <div>{showGoals(match, match.teams[0].id)}</div>
              <div>:</div>
              <div>{showGoals(match, match.teams[1].id)}</div>
            </div>) : (<div className={styles.info}>
              <div>{match.court_name}</div>
              <div>{func.showHourMinutes(match.start_time)}</div>
            </div>)}
          </div>

          <div>

            {func.canReportMatch(user, leagueId) ? (<img
              className={styles.iconWhisle}
              src={whisleIcon}
              alt="עדכון תוצאה"
              onClick={() => {
                setMatches(roundMatches);
                history.push(`/leagues/${leagueId}/rounds/${match.round}/matches/${match.id}`);
              }}
            />) : (<span></span>)}
          </div>

          <div>
            {match.teams[1] && <div>
              <div className={styles.groupName}>{match.teams[1].name}</div>
              <img
                className={styles.groupImg}
                src={match.teams[1].image !== null ? match.teams[1].image :
                  'https://images.unsplash.com/photo-1527871252447-4ce32da643c6?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=2389&q=80'}
                alt={match.teams[1].name}
              />
            </div>}
          </div>

        </> :
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <span style={{ textAlign: 'center', minWidth: '60vw', padding: '10px', lineHeight: '24px',  }}>
          <p style={{paddingBottom: '10px'}}>
         שגיאה: לא נמצאו קבוצות
            למשחק
          </p>
<p>
   עם מזהה
  &nbsp;
  {match.id}
</p>

        </span>
        </div>}

    </div>))) : (<div className={styles.noMatches}>
      {isLoaded ? (<div>משחקי המחזור יפורסמו בהמשך</div>) :
        (<div>משחקי המחזור נטענים</div>)}
    </div>)}
  </div>);
}

export default RoundTable;
